import logger from './logger';
/**
 * Utility functions for URL operations
 */

/**
 * Extracts UTM parameters from the current URL
 * @returns {Object} Object containing UTM parameters
 */
export const extractUTMParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = {};
  
  // Common UTM parameters
  const utmKeys = [
    'utm_source', 
    'utm_medium', 
    'utm_campaign', 
    'utm_term', 
    'utm_content',
    'utm_id',
    'utm_source_platform',
    'utm_creative_format',
    'utm_marketing_tactic'
  ];
  
  utmKeys.forEach(key => {
    const value = urlParams.get(key);
    if (value) {
      utmParams[key] = value;
    }
  });
  
  // Also preserve other common tracking parameters
  const trackingKeys = [
    'gclid',        // Google Ads
    'fbclid',       // Facebook
    'msclkid',      // Microsoft Ads
    'ref',          // Referral
    'source',       // Generic source
    'medium',       // Generic medium
    'campaign'      // Generic campaign
  ];
  
  trackingKeys.forEach(key => {
    const value = urlParams.get(key);
    if (value) {
      utmParams[key] = value;
    }
  });
  
  return utmParams;
};

/**
 * Builds a URL with UTM parameters
 * @param {string} basePath - The base path (e.g., '/signin')
 * @param {Object} utmParams - UTM parameters to add
 * @returns {string} URL with UTM parameters
 */
export const buildURLWithUTM = (basePath, utmParams = {}) => {
  if (Object.keys(utmParams).length === 0) {
    return basePath;
  }
  
  const urlParams = new URLSearchParams();
  Object.entries(utmParams).forEach(([key, value]) => {
    if (value) {
      urlParams.append(key, value);
    }
  });
  
  return `${basePath}?${urlParams.toString()}`;
};

/**
 * Gets the signin URL with preserved UTM parameters
 * @returns {string} Signin URL with UTM parameters
 */
export const getSigninURLWithUTM = () => {
  const utmParams = extractUTMParams();
  const signinURL = buildURLWithUTM('/signin', utmParams);
  
  // Log for debugging
  if (Object.keys(utmParams).length > 0) {
    logger.log('🔗 Preserving UTM parameters:', utmParams);
    logger.log('🔗 Redirecting to:', signinURL);
  }
  
  return signinURL;
};

/**
 * Gets the signin URL with ALL preserved URL parameters (not just UTM)
 * @returns {string} Signin URL with all URL parameters
 */
export const getSigninURLWithAllParams = () => {
  const currentSearch = window.location.search;
  const signinURL = '/signin';
  
  if (currentSearch) {
    logger.log('🔗 Preserving all URL parameters:', currentSearch);
    logger.log('🔗 Redirecting to:', `${signinURL}${currentSearch}`);
    return `${signinURL}${currentSearch}`;
  }
  
  return signinURL;
};
